import React, { useEffect } from "react";
import Stage from "../../../../components/Stage";

const ThankYouVTPUsados = () => {

    const [infoNameForm, ] = React.useState("Quiero un auto usado");
    const [infoImage, ] = React.useState("autos-usados-2022.jpg");

    useEffect(() => {
        document.title = "Gracias - Quiero un auto usado";
    }, []);

    return (
        <>
            <div className="">
                <Stage title={infoNameForm} img={process.env.REACT_APP_RESOURCES_IMAGES_PATH + "formsSalesforce/" + infoImage} positionTitle="bottom" />
                <div className="mb-5"></div>
                <section className="container pb-5">
                    <div className="row pt-5">
                        <div className="col-12">
                            <h1 className="text-center">Gracias por contactarnos</h1>
                            <p className="text-center mt-5 pt-4 mb-5">Estamos procesando tu solicitud, a la brevedad uno de nuestros asesores se pondrá en contacto contigo para darte seguimiento a tu interés de compra.</p>
                            <p className="text-center mt-5 pt-1 mb-5">Para tu comodidad y seguridad, te informamos que nos estaremos comunicando desde el número: <strong>222 179 1156</strong>, esto con la finalidad de dar seguimiento a tu solicitud y atenderte como lo mereces.</p>
                            <div className="text-center mb-5 pb-5">
                                <button className='button-enviar mt-5 mb-5' type='button' onClick={() =>
                                    (window.location = "https://www.audi.com.mx/mx/web/es.html")
                                }>
                                    Ir al Home
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default ThankYouVTPUsados;